export default __webpack_public_path__ + "static/media/43_2_1.195585b5.png";